import React, {useEffect, useState} from 'react';
import Card from '@mui/material/Card';
import {useFormikContext} from 'formik';
import {TextField, Autocomplete} from '@mui/material';
import {museumApi} from '../../../services/MuseumServices';

export default function TransferEntryThree(code) {
  const {values, setFieldValue} = useFormikContext();
  const [museums, setMuseums] = useState([]);
  const [selectedMuseum, setSelectedMuseum] = useState(null);

  useEffect(() => {
    getMuseumList();
  }, []);

  useEffect(() => {
    if (values?.museum_id) {
      setSelectedMuseum(null);
      setFieldValue('recipient_museum_id', null);
    }
  }, [values?.museum_id]);

  const getMuseumList = () => {
    museumApi('get', null, {per_page: 100}).then(response => {
      setMuseums(response?.data);
    })
  }

  const getDisplayValue = (value) => {
    if (!value) return '';
    if (typeof value === 'object') {
      return value?.name || value?.code || '';
    }
    return value;
  };

  return (
    <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 5}}>
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Condition'}
        value={getDisplayValue(values?.condition)}
        disabled
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Storage Location'}
        value={getDisplayValue(values?.storage_location)}
        sx={{mt: 1.5}} 
        disabled
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth 
        label={'Place of Origin'}
        value={getDisplayValue(values?.place_of_origin)}
        sx={{mt: 1.5, mb: 1.5}} 
        disabled
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'},
          shrink: true
        }}
      />
      <Autocomplete
        id="combo-box-demo"
        options={museums.filter(m => m?.id !== values?.museum_id)}
        getOptionLabel={(option) => (option?.name)}
        value={selectedMuseum}
        size={'small'}
        className="dob mr-2 mt-3"
        onChange={(e, value) => {
          setSelectedMuseum(value);
          setFieldValue('recipient_museum_id', value?.id || null);
        }}
        renderInput={(params) => (
          <TextField 
            {...params}
            placeholder="Select Museum"
            label={
              <div>
                <span style={{color: 'red'}}>*</span>
                Select recipient museum
              </div>
            }
            helperText={values?.museum_id ? "Recipient museum cannot be the same as initiator museum" : ""}
            InputLabelProps={{style: {color: '#929191', fontSize: 14}}}
          />
        )}
      />
      <TextField 
        variant={'outlined'} 
        size={'small'} 
        fullWidth
        label={
          <div>
            <span style={{color: 'red'}}>*</span>
            Justification
          </div>
        }
        value={values?.remarks || ''}
        onChange={(e) => setFieldValue('remarks', e.target.value)}
        sx={{mt: 1.5}} 
        multiline 
        minRows={5} 
        maxRows={10}
        InputLabelProps={{
          style: {fontSize: 14, color: '#929191'}
        }}
      />
    </Card>
  );
}